<mat-form-field>
    @if (matIcon()) {
        <mat-icon matPrefix>{{ matIcon() }}</mat-icon>
    }
    <mat-label>{{ matLabelText() }}</mat-label>
    <mat-select #typeCB (valueChange)="onChangeEvent($event)">
        <mat-option [value]="">---</mat-option>
        @for (kind of kinds; track kind) {
            <mat-option [value]="kind.value">{{ kind.option | transloco }}</mat-option>
        }
    </mat-select>
</mat-form-field>
